// extracted by mini-css-extract-plugin
module.exports = {"Instruction":"Instruction_Instruction__3Q745"};